/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { HOME_CONSTANTS } from '../../app.constants';
import { UtilityService, TaggingService } from '@shared/utils/services';
import { chain } from '@core/chain';

@Component({
    selector: 'home-quickview-cta',
    templateUrl: './quickview-cta.component.html',
    styleUrls: ['./quickview-cta.component.scss'],
    standalone: false
})
export class QuickviewCtaComponent implements OnInit {
	@Input() data: any;
	@Input() addlData: any;
	@Input() ecode: string;
	@Input() ctaText: string;
	@Input() buttonVariant: string;
	public targetService: any;
	public isGGStaticPage: boolean;
	public ggStaticColors = HOME_CONSTANTS.ggStaticColors;

	constructor(
		public taggingService: TaggingService,
		private utilityService: UtilityService
	) {
		this.targetService = this.utilityService.target;
	}

	ngOnInit() {
		this.isGGStaticPage = this.utilityService.ggStaticPage(this.addlData.isStaticPage);
		this.buttonVariant = 'tertiary';
		this.ecode = this.data.ecode;
		this.ctaText = this.data.ctaText;
	}

	public useProductQuickView(contentId) {
		window.quickview.openProductQuickView(contentId, window.location.pathname);
	}

	ctaIcon() {
		let icon = 'arrow_forward';
		icon = chain.chainIdentifierAbbr === 'gg' ? 'chevron_right' : icon;
		icon = chain.chainIdentifierAbbr === 'pl' ? 'pl_arrow_forward' : icon;
		return icon;
	}
}
